export enum ContractStep {
  Contact,
  Vehicle,
  Payment,
  Client,
  Beneficiary,
  Document,
  DocumentPostsale,
  Summary,
}

export const contractStepValues: any = {
  0: 'Contacto',
  1: 'Venta',
  2: 'Pagos',
  3: 'Cliente',
  4: 'Beneficiario Controlador',
  5: 'Cierre',
  6: 'Postventa',
  7: 'Expediente',
};

export namespace ContractStep {
  export function after(value: ContractStep): ContractStep {
    if (value == 7) return 7;
    return value + 1;
  }

  export function values() {
    return Object.keys(ContractStep)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: contractStepValues[index], value: index };
      });
  }

  export function toArray() {
    return Object.keys(ContractStep)
      .filter((type) => typeof ContractStep[type as any] === 'number')
      .map((key) => ContractStep[key]);
  }

  const stringIsNumber = (value) => isNaN(Number(value)) !== false;
}
